export default __webpack_public_path__ + "static/media/active-bullseye.6c7de2a8.svg";